import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import { useTranslation } from 'react-i18next';
import HiddenIcon from '@wix/da-ds/pkg/Icons/32x32/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import HiddenLayout from './HiddenLayout';
const MatureStrictBlockedOverlay = (props)=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement(HiddenLayout, _object_spread({
        icon: /*#__PURE__*/ React.createElement(HiddenIcon, {
            size: IconSize.HUGE
        }),
        text: t('deviationview.blocked.mature.text')
    }, props));
};
MatureStrictBlockedOverlay.displayName = 'MatureStrictBlockedOverlay';
export default MatureStrictBlockedOverlay;

//# sourceMappingURL=MatureStrictBlocked.js.map